<template>
  <no-auth-layout>
    <div class="pass-forgot-page" v-if="!data.success">
      <h2 class="card-title center-align">Przypomnij hasło</h2>
      <p class="card-subtitle center-align">
        Podaj adres e-mail, którego uzyłeś do rejestracji.<br>
        Wyślemy do Ciebie wiadomość z linkiem umożliwiającym ustawienie nowego hasła.
      </p>

      <div class="email-auth-container">
        <div class="line-through-header center-align">
          <span>Wprowadź e-mail użyty przy rejestracji:</span>
        </div>

        <form @submit.prevent="submit()">
          <div v-if="data.errors" class="center-align validation-errors">
            <span class="red-text" v-if="data.errors['message']">{{ data.errors['message'].join(', ') }}</span>
            <span class="red-text" v-else>Użytkownik o podanym adresie e-mail nie istnieje</span>
          </div>

          <input-field type="email" name="email"
            label="Adres e-mail" v-model="data.email"
            @updateError="val => data.errors['email'] = val"
            required="true" :errors="data.errors['email']" />

          <button class="btn-large z-depth-0" type="submit">Przypomnij hasło</button>
        </form>
      </div>
      <br>
      <div class="card-footer">
        Jeśli nadal potrzebujesz pomocy,<br/>
        wyślij email na <a href="mailto:partnerzy@punkta.pl"> partnerzy@punkta.pl </a>
      </div>
    </div>
    <div class="pass-forgot-page center-align" v-if="data.success">
      <img src="../assets/send_email.png" alt="email wysłany">
      <h2 class="card-title">Sprawdź skrzynkę</h2>
      <p class="card-subtitle">
        Nowe hasło zostało wysłane na podany przez Ciebie adres e-mail.
      </p>
      <router-link :to="{ name: 'login' }">
        <button class="btn-large z-depth-0">
          <i class="mfind-icon-back left"></i>
          Wróć do logowania
        </button>
      </router-link>
      <div class="card-footer">
        Jeśli nadal potrzebujesz pomocy,<br/>
        wyślij email na <a href="mailto:partnerzy@punkta.pl"> partnerzy@punkta.pl </a>
      </div>
    </div>
    <Loader :loading="data.loading"/>
  </no-auth-layout>
</template>

<script>
import NoAuthLayout from '@/layouts/noAuthLayout'
import InputField from '@/components/inputs/text'
import Loader from '@/components/loader'
export default {
  name: 'passForgot',
  components: { NoAuthLayout, InputField, Loader },
  data () {
    return {
      data: {
        loading: false,
        email: '',
        success: false,
        errors: false
      }
    }
  },
  beforeCreate () {
    if (this.$store.getters.isLoggedIn) {
      // redirect to auth change password
    }
  },
  methods: {
    submit () {
      this.data.loading = true
      this.$store.dispatch('passForgot', {
        user: { email: this.data.email }
      })
      .then(
        response => {
          this.data.loading = false
          if (response.code === 200) {
            this.data.success = true
          }
        },
        errorResponse => {
          this.data.loading = false
          this.data.errors = errorResponse.errors
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// passForgot.vue?6934c4cd